

let _ = require('../_.js');
let $ = jQuery;

// Poor mans router for navigating between SPA pages within the auction page.

// The intention is that we should be able to go to the:

// Front page
// Bidding on a specific lot
// The lots page
// The lots details page

// And each of these pages should appear to be and behave as an actual web page,
// when in reality the auction page is serving all of the content dynamically.

// To register a callback to hash based navigation call:
//  _.AuctionUI_Router.on_navigate(callback_match, callback_hide, callback_show).
// When a link with a # is followed, it will be navigated to, or go to the front page if none.
// Each callback_match will be called and if callback_match returns true, callback_show will be 
// called, otherwise callback_hide.

let _callbacks = [];

let old_hash = '';

_.AuctionUI_Router = class AuctionUI_Router {

    // Hook clicks to A tag, and back button
    static init() {

        // Back button pops hash
        let handleChange = function () {
            let hash = window.location.hash.substring(1);
            _.AuctionUI_Router.navigate_to(hash);
        }

        window.addEventListener('hashchange', handleChange);
        window.addEventListener('popstate', handleChange);

        // Intercept 'a' clicks
        document.addEventListener('click', (e) => {
            if (e.target.tagName === 'A') {
                let href = e.target.getAttribute('href');
                if (href && href.startsWith('#')) {
                    e.preventDefault();
                    _.AuctionUI_Router.navigate_to(href.substring(1));
                }
            }
        });
    }

    // The final thing called after auctionui initializes, this dispatches the initial navigation.
    static async on_ready() {
        const hash = window.location.hash.substring(1);

        let did_navigate = false;

        if (hash) {
            did_navigate = _.AuctionUI_Router.navigate_to(hash);
        }

        if (did_navigate) {
            return;
        }

        // Try to find an auction item to show.

        // Pick first item in list, or item indicated by hash if any
        let items = await _.ac_state.auction.auction_items.fetch();

        let best_item = null;

        if (items.length == 1) {
            best_item = items[0];
        }

        // Priority 1: currently highlighted item
        if (!best_item) {
            for (let item of items) {
                if (_.ac_state.auction.highlighted_item_id == item.id) {
                    best_item = item;
                }
            }
        }

        // Priority 2: first active item
        if (!best_item) {
            for (let item of items) {
                if (item.status == App_Models_AuctionItem.STATUS_AVAILABLE) {
                    if (item.round) {
                        let round = await item.round.fetch();
                        if (round.status_can_bid) {
                            // Standard
                            best_item = item;
                            break;
                        }
                    } else {
                        // Choice
                        best_item = item;
                        break;
                    }
                }
            }
        }

        // Priority 3: first item
        if (!best_item && items.length >= 1) {
            best_item = items[0];
        }

        if (best_item) {
            _.AuctionUI.set_current_item(best_item.id);
        }
    }

    // Just set current page, don't execute navigation.  Still calls change callback.
    static update_history(hash) {
        if (hash === null) {
            hash = '';
        }

        let current_hash = window.location.hash.substring(1);

        if (!current_hash) {
            current_hash = '';
        }

        // Update URL
        if (current_hash != hash) {
            history.pushState(null, null, '#' + hash);
        }

        old_hash = hash;

        let i = _.AuctionUI_Router._match_hash_to_route(hash);

        if (i && _callbacks[i][3]) _callbacks[i][3](hash);
    }

    static _match_hash_to_route(hash) {
        for (let i in _callbacks) {
            // Match
            let result = _callbacks[i][0](hash);
            if (result) {
                return i;
            }
        }
        return null;
    }

    static _hide_all_except(index, hash) {
        for (let i in _callbacks) {
            if (i != index && _callbacks[i][2]) {
                _callbacks[i][2](hash);
            }
        }
    }

    // Navigates to a SPA page by hash (url).
    static async navigate_to(hash) {

        if (hash == old_hash) {
            return true;
        }

        console.warn("Navigating to SPA hash " + hash)

        _.Modal.hide();

        // window.scrollTo(0, 0);

        let i = _.AuctionUI_Router._match_hash_to_route(hash);

        // Route not found
        if (!i) {
            if (hash != '') {
                console.log(hash); return;
                // Replace url with index so back button wont go back to an invalid page
                history.replaceState(null, null, '#');
                // Redirect to index
                _.AuctionUI_Router.navigate_to("");
                window.location.reload();
                return false;
            } else {
                // Programmer messed up if this happens
                console.error("No match for empty hash (index page), this shouldn't happen");
                return false;
            }
        }

        _.AuctionUI_Router._hide_all_except(i, hash);

        let current_hash = window.location.hash.substring(1);

        // Update URL
        if (current_hash != hash) {
            history.pushState(null, null, '#' + hash);
        }

        old_hash = hash;

        // Execute callback
        if (_callbacks[i][1]) {
            return await _callbacks[i][1](hash);
        }

        return false;
    }

    // Callbacks for handling navigation register here.
    static on_navigate(callback_match, callback_change) {
        _callbacks.push([callback_match, callback_change]);
    }

}